/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';
import { cva, VariantProps } from 'class-variance-authority';

export const dropdownMenuItemVariants = cva('block min-h-12 p-1 first:mt-2 last:mb-2 cursor-default text-text', {
  variants: {
    size: {
      full: 'flex-1',
    },
    padding: {
      'bottom-large': 'px-4 pt-1 pb-3',
      large: 'p-4',
    },
    background: {
      white: 'bg-whitetext',
    },
  },
});

export type DropdownMenuItemVariants = VariantProps<typeof dropdownMenuItemVariants>;

@Component({
  selector: 'ods-dropdown-menu-item',
  host: {
    role: 'listitem',
    '[class]': 'dropdownMenuItemVariants({ size, background, padding })',
  },
  template: `<ng-content />`,
})
export class DropdownMenuItemComponent {
  @Input() size: DropdownMenuItemVariants['size'];
  @Input() background: DropdownMenuItemVariants['background'];
  @Input() padding: DropdownMenuItemVariants['padding'];

  readonly dropdownMenuItemVariants = dropdownMenuItemVariants;
}
